<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="notifications.length"/>

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ notifications.length }} {{ showOnlyUnread ? 'New' : 'All' }}</h3>
        <p class="opacity-75">App Notifications</p>
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10"
                 :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items">

          <li class="flex justify-between px-4 py-4 notification">
            <div class="flex items-start">
            </div>
            <small class="mt-1 whitespace-no-wrap cursor-pointer hover:text-primary" @click.stop="onClickMarkAllAsRead">
              Mark all as read
            </small>
          </li>

          <li v-for="(ntf, index) in notifications" :key="index"
              class="flex justify-between px-4 py-4 notification cursor-pointer"
              v-on:click="onClickNoti(ntf.id, ntf.read_at, ntf.data.url)">
            <div class="flex items-start">
              <feather-icon :icon="'MessageSquareIcon'"
                            :svgClasses="[`text-${getCategory}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
              <div class="mx-2">
                <span class="font-medium block notification-title" :class="[`text-${getCategory}`]">{{
                    ntf.data.title
                  }}</span>
                <small>{{ ntf.data.description }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.created_at) }}</small>
            <small class="mt-1 whitespace-no-wrap">
              <vx-tooltip v-if="!ntf.read_at" text="Mark As Read" position="top">
                <feather-icon @click.stop="onClickMarkAsRead(ntf.id)" :icon="'CheckIcon'"
                              :svgClasses="[`text-primary`, 'stroke-inherit ml-2 mt-1 h-3 w-3']"></feather-icon>
              </vx-tooltip>
              <vx-tooltip v-if="ntf.read_at" text="Mark As Un-Read" position="top">
                <feather-icon @click.stop="onClickMarkAsUnRead(ntf.id)" :icon="'MailIcon'"
                              :svgClasses="[`text-danger`, 'stroke-inherit ml-2 mt-1 h-3 w-3']"></feather-icon>
              </vx-tooltip>
            </small>

          </li>
        </ul>
      </component>

      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
        <span>
<!--          {{ notifications.length > 0 ? 'View All Notifications' : 'No new notifications' }}-->
          <div class="md:flex md:items-center">
            <div class="md:w-full">
              <label class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">
                Only show unread?
              </label>
            </div>
            <div class="md:w-2/3">
              <vs-switch class="" v-model="showOnlyUnread" v-on:input="onClickNotificationControl()"/>
            </div>
          </div>

        </span>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {mapActions, mapGetters} from "vuex";
import Pusher from 'pusher-js'
import ErrorMessages from "@/mixins/ErrorMessages";
import { APP_TENANT, APP_NAME, APP_PORTAL } from "@/constants/config";
import { pusher } from "@/constants/pusher";

export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      showOnlyUnread: true,
      settings: {
        maxScrollbarLength: 80,
        wheelSpeed: .60
      },
    }
  },
  mixins: [ErrorMessages],
  mounted() {
    this.onClickNotificationControl()
  },
  computed: {
    ...mapGetters(['notifications', 'currentUserId']),
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    getCategory: function () {
      return 'primary'
    },
  },
  created() {
    this.$notification.requestPermission()
      .then(console.log)

    const channel = pusher.subscribe(`notifications-${APP_NAME}-${APP_TENANT}-${APP_PORTAL}-${this.currentUserId}`);
    const vm = this
    const callback = (eventName, data) => {
      this.onClickNotificationControl()
      if(data.title) {
        // this.$vs.notify({
        //   title: data.title ? data.title : 'New Notification',
        //   text: data.description ? data.description : '',
        //   color: 'primary',
        //   iconPack: 'feather',
        //   position:'top-right',
        //   icon:'icon-bell'})
        vm.$notification.show(data.title ? data.title : 'New Notification', {
          body: data.description ? data.description : ''
        }, {
          onclick: function () {
            if(data.url) {
              vm.$router.push({path: '/' + data.url})
            }
          },
        })
      }
    };
    channel.bind_global(callback);
  },
  methods: {
    ...mapActions(['markAsReadNotification', 'markAsUnReadNotification', 'fetchNotifications', 'markAllAsReadNotification']),
    async onClickNoti(id, read_at, url) {
      try {
        if (!read_at) {
          await this.markAsReadNotification({id: id, showOnlyUnread: this.showOnlyUnread})
        }
        if (url && this.$router.currentRoute.fullPath !== '/'+url) {
          this.$router.push({path: '/' + url})
        }
        if (!url) {
          this.$vs.dialog({
            color: 'danger',
            title: `Access Denied`,
            text: ' You don\'t have permission to access this resource',
            acceptText: 'Close'
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    onClickMarkAsRead(id) {
      this.markAsReadNotification({id: id, showOnlyUnread: this.showOnlyUnread})
    },
    onClickMarkAsUnRead(id) {
      this.markAsUnReadNotification({id: id, showOnlyUnread: this.showOnlyUnread})
    },
    onClickNotificationControl() {
      this.fetchNotifications(this.showOnlyUnread)
    },
    onClickMarkAllAsRead() {
      this.showOnlyUnread = false
      this.markAllAsReadNotification()
    },
    elapsedTime(startTime) {
      const x = new Date(startTime)
      const now = new Date()
      let timeDiff = now - x
      timeDiff /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff = Math.floor(timeDiff / 60)

      const hours = Math.round(timeDiff % 24)
      timeDiff = Math.floor(timeDiff / 24)

      const days = Math.round(timeDiff % 365)
      timeDiff = Math.floor(timeDiff / 365)

      const years = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' Years ' : ' Year ')}ago`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Days ' : ' Day ')}ago`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hour ')}ago`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}ago`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now')
      }

      return 'Just Now'
    },
    // Method for creating dummy notification time
    randomDate({hr, min, sec}) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    }
  }
}

</script>

<style>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #52e327;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>

